import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TaskInitApi, TaskInitRequest, TaskInitResponse } from '../task-init-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class TaskInitApiImpl extends GuestAwareHttpService implements TaskInitApi {
    async initTask(request: TaskInitRequest): Promise<TaskInitResponse> {
        const res = await this.postWithGuestSupport<TaskInitResponse>(
            {
                data: request,
            },
            'task/init'
        );
        return res;
    }
}
